import React, { useEffect } from "react";

import EmpresaParametros from "../components/EmpresaParametros/EmpresaParametros";
import i18n from "../i18n/config";

const EmpresaSelectParametrosPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("pageTitle", { ns: "empresaParametros" })}`;
  }, []);

  return <EmpresaParametros />;
};

export default EmpresaSelectParametrosPage;
